// 首页 Hero 接口数据标准化
import { normalizeColumnItem } from '@/components/home/utils/heroColumnRows'
import { buildRowBackgroundCss, isCssGradient } from '@/components/home/utils/heroRowBackground'
import { filterVisibleTexts, filterVisibleButtons } from '@/components/home/utils/heroTextBlocks'

/** 过滤 hero 文字列表，移除元数据与空文本 */
function normalizeTexts(texts) {
  return filterVisibleTexts(texts)
}

/** 将 hero 条目背景配置转为 Vue 内联样式对象 */
export function resolveHeroItemBackgroundStyle(item) {
  const raw = item?.backgroundStyle
  const css = typeof raw === 'string' ? raw.trim() : buildRowBackgroundCss(raw)
  if (!css) return {}
  return isCssGradient(css) ? { background: css } : { backgroundColor: css }
}

/** 标准化单个 hero 轮播条目（含 COLUMN 与普通类型） */
function normalizeHeroItem(item) {
  const itemType = item.itemType || 'IMAGE'

  if (itemType === 'COLUMN') {
    const normalized = normalizeColumnItem(item)
    normalized.rows = (normalized.rows || []).map((row) => ({
      ...row,
      texts: normalizeTexts(row.texts)
    }))
    return normalized
  }

  return {
    ...item,
    itemType,
    texts: normalizeTexts(item.texts),
    buttons: filterVisibleButtons(item.buttons)
  }
}

/** 标准化首页 Hero 轮播整体数据 */
export function normalizeHeroData(data) {
  if (!data) {
    return {
      mode: 'CAROUSEL',
      intervalMs: 5000,
      enabled: false,
      items: []
    }
  }

  // 项
  const items = (data.items || [])
    .map(normalizeHeroItem)
    .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))

  return {
    mode: data.mode || 'CAROUSEL',
    intervalMs: data.intervalMs ?? 5000,
    enabled: data.enabled !== false,
    items
  }
}
